/**
 * @deprecated 不允许再使用此配置文件，请使用多语言配置
 */
export const ApiCode = {
    A101B211184: "The user's email does not exist!",
    A101B2300003: "username or password not correct!",
    A101B211187: "The email exists match user",
    A101B21620956: "oldPassword incorrect",
    A101B21850982: "verifyToken expire",    
    A101B22417899: "emailAddress already used",

    // 退货模块
    // TODO 临时error 提示
    A101B23180698: "The order item id does not exist",
    A101B23356378: "Current item does not allow to return",
    A101B23356585: "Shipment time has been more than 30 days",
    A101B23181121: "The current item is in return status",

    // 拼单模块
    // TODO 临时error提示
    A101B200458: "no areaShippingConfig matched in areaShippingConfigGroup",

    // 购物车预拼单列表
    A101B2000475: "Incorrect email address",

    // 登录模板
    A101B23000001: "User Id is not exists",

    // 重复添加产品错误提示
    A101B22259959: "* This product has already added into the stores in red shade, please choose another one.",

}